import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import { usePageMeta } from '@/hooks/usePageMeta';
import { PHASES } from '@/mocks/schedule';
import ScheduleHero from '@/pages/schedule/components/ScheduleHero';
import TimelineSection from '@/pages/schedule/components/TimelineSection';
import MilestoneTable from '@/pages/schedule/components/MilestoneTable';

export default function Schedule() {
  const jsonLd = useMemo(
    () => [
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: '爆料大赛赛程时间表 - 七个阶段起止时间与关键节点',
        description:
          '爆料大赛完整赛程时间表，包含报名海选、资格初审、初赛公投、复赛评审、半决赛、决赛与颁奖各阶段起止时间。',
        inLanguage: 'zh-CN',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: '/' },
          { '@type': 'ListItem', position: 2, name: '赛程时间表', item: '/schedule' },
        ],
      },
      {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        name: '爆料大赛赛程阶段',
        itemListElement: PHASES.map((p, i) => ({
          '@type': 'ListItem',
          position: i + 1,
          name: p.name,
          description: p.summary,
        })),
      },
    ],
    [],
  );

  usePageMeta({
    title: '爆料大赛赛程时间表 - 七个阶段起止时间与关键节点',
    description:
      '爆料大赛赛程时间表：报名海选、资格初审、初赛公投、复赛评审、半决赛晋级、决赛冲刺与颁奖的起止时间一览，含截稿、开投、出结果全部关键节点。',
    keywords: '爆料大赛赛程,爆料大赛时间表,爆料大赛比赛进度,爆料大赛日程,爆料大赛活动安排',
    path: '/schedule',
    jsonLd,
  });

  return (
    <SiteLayout>
      <ScheduleHero />
      <TimelineSection />
      <MilestoneTable />

      <section className="w-full px-4 md:px-6 pb-16 md:pb-24 bg-background-100">
        <div className="max-w-6xl mx-auto rounded-lg bg-secondary-950 px-6 md:px-10 py-8 md:py-10 flex flex-col md:flex-row md:items-center justify-between gap-6">
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-background-50">
              看完时间表，再了解参赛方式和奖项
            </h2>
            <p className="mt-2 text-sm text-background-300">
              活动安排页汇总了提交方式、材料规范、评审规则与六个奖项的设置。
            </p>
          </div>
          <Link
            to="/arrangement"
            className="shrink-0 px-6 py-3 rounded-md bg-accent-500 text-secondary-950 text-sm font-medium whitespace-nowrap hover:bg-accent-400 transition-colors cursor-pointer"
          >
            前往活动安排
          </Link>
        </div>
      </section>
    </SiteLayout>
  );
}